import { add, listen, qsa } from "@fluorescent/dom";
import { emit } from "@/glow/events";
import { cart } from "@/glow";

const selectors = {
  quickAddTrigger: "[data-quick-add-trigger]",
  addToCartTrigger: "[data-add-item-id]",
};

export default function CrossSells(node) {
  const events = [
    listen(qsa(selectors.quickAddTrigger, node), "click", e => {
      const { productUrl, title } = e.currentTarget.dataset;
      if (!productUrl) return;

      emit("quick-add:open", null, {
        type: "quick-add",
        productUrl: productUrl,
        productTitle: title,
      });
    }),
    listen(qsa(selectors.addToCartTrigger, node), "click", e => {
      const { addItemId } = e.target.dataset;
      if (!addItemId) return;

      animateButton(e.target);
      cart.addItemById(addItemId, 1);
      emit("quick-cart:scrollup");
    }),
  ];

  function animateButton(button) {
    add(button, "loading");
  }

  function unload() {
    events.forEach(unsubscribe => unsubscribe());
  }

  return { unload };
}
